<template>
  <v-container fluid pa-0 ma-0>
    <v-container fluid pa-0 ma-0 class="test_purple header-background">
      <v-row no-gutters align="start">
        <div class="header">
          <MenuHeaderPublic />
        </div>
        <v-row
          v-if="!showModal"
          class="img-bc ma-0"
          :class="showInfoCheckout ? 'img-bc-mt' : null"
        >
          <v-img
            class="align-end justify-center display-1"
            :height="$vuetify.breakpoint.xs ? '230px' : '290px'"
            width="100vw"
            :src="$store.getters.storeInfo.menuImage ?? banner"
            cover
            :eager="true"
            gradient="to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.8)"
            :light="true"
          >
            <template v-slot:placeholder class="pl-0">
              <v-row
                class="fill-height ma-0 pl-0"
                align="center"
                justify="center"
              >
                <v-progress-circular indeterminate color="primary" />
              </v-row>
            </template>
            <v-col
              :class="{ 'img-inner-container': $vuetify.breakpoint.lgAndUp }"
            >
              <v-card-title
                class="store-title font-weight-bold"
                :class="{
                  'pl-0': $vuetify.breakpoint.smAndDown,
                  'pl-6': $vuetify.breakpoint.lgAndUp,
                }"
                v-text="$store.getters.storeInfo.storeName"
              />
              <v-card-subtitle
                class="store-subtitle"
                :class="{
                  'pl-0': $vuetify.breakpoint.smAndDown,
                  'pl-6': $vuetify.breakpoint.lgAndUp,
                }"
                v-text="$store.getters.storeInfo.storeAddress"
              />
            </v-col>
          </v-img>
        </v-row>
        <StoreInfoBar
          v-if="
            !showModal &&
            ($vuetify.breakpoint.smAndDown ||
              (!$store.getters.cartDetails &&
                $store.getters.storeInfo.isOpenNow))
          "
        />
        <div v-if="!showModal" id="tagbarid" ref="tagBar" class="menu">
          <CheckoutBar
            v-if="
              $vuetify.breakpoint.mdAndUp && $store.getters.storeOnline.status
            "
            :show-info="showInfoCheckout"
          />
          <v-row ref="categoryBar" style="max-width: 100vw">
            <CategoryBar @handleTabSelect="handleTabSelect" />
          </v-row>
        </div>
        <!--        <v-row ref="categoryBar">-->
        <!--          <CategoryBar />-->
        <!--        </v-row>-->
      </v-row>
    </v-container>

    <v-container
      v-if="!showModal"
      id="container-discovery"
      fluid
      class="test_green container-discovery bg-color"
      :class="{
        'content-mobile': $vuetify.breakpoint.xs,
        'bg-color-mobile': $vuetify.breakpoint.xs,
      }"
    >
      <v-row justify="center" class="test_yellow category-container">
        <!--        <ProductList />-->
        <v-col cols="24" class="test_green">
          <ProductList ref="productList" />
        </v-col>
        <!--        <v-col cols="12" md="3" class="test_yellow">-->
        <!--          <CategoryList />-->
        <!--        </v-col>-->
        <!--        <v-col cols="12" md="7" lg="6" class="test_green">-->
        <!--          <ProductList />-->
        <!--        </v-col>-->

        <!--        <v-col-->
        <!--          v-if="!$vuetify.breakpoint.mobile && $store.getters.storeInfo"-->
        <!--          cols="3"-->
        <!--          class="test_orange"-->
        <!--        >-->
        <!--          <OffersComponent />-->
        <!--          <StoreInfo />-->
        <!--        </v-col>-->
      </v-row>
    </v-container>
    <div
      v-if="showModal"
      style="
        background-color: #ffffff;
        height: 100%;
        width: 100%;
        padding: 10px;
        padding-top: 50px;
        justify-content: flex-start;
        align-items: center;
        display: flex;
        flex-direction: column;
      "
    >
      <v-card
        class="mx-auto"
        elevation="1"
        max-width="500"
        style="text-align: center; justify-content: center; align-items: center"
      >
        <v-card-title
          class="py-5 font-weight-black"
          style="text-align: center; justify-content: center"
          v-text="$t('general.confirmTable')"
        />

        <v-card-text
          style="text-align: center; justify-content: center"
          v-text="$t('general.confirmTableDesc')"
        />

        <v-card-text style="text-align: center">
          <v-text-field
            v-model="tableIdInput"
            :label="$t('general.findMyTablePlaceholder')"
            single-line
            append-icon="mdi-qrcode"
            variant="outlined"
            style="display: block; margin-left: auto; margin-right: auto"
          ></v-text-field>

          <v-btn
            block
            class="text-none mb-4"
            color="#67ac79"
            size="x-large"
            variant="flat"
            style="
              display: block;
              margin-left: auto;
              margin-right: auto;
              color: #fff;
            "
            @click="validateRoute(tableIdInput, true)"
          >
            {{ $t("general.findMyTable") }}
          </v-btn>
          <v-card-text
            style="
              text-align: center;
              justify-content: center;
              font-weight: bold;
            "
            v-text="$t('general.findMyTableDesc')"
          />
        </v-card-text>
      </v-card>
    </div>
    <v-footer
      v-if="!$vuetify.breakpoint.mobile"
      fixed
      padless
      elevation="10"
      class="test_red"
      color="transparent"
      style="background-color: transparent !important"
    >
      <StoreCloseNotification class="test_blue" />
    </v-footer>

    <v-footer
      v-if="$vuetify.breakpoint.smAndDown && !showModal"
      fixed
      padless
      elevation="10"
    >
      <StoreCloseNotification class="test_blue" />
      <OffersComponent />
      <CheckoutBar v-if="$store.getters.storeOnline.status" />
    </v-footer>
    <MetaDataComponent
      v-if="metaTitle && metaDescription && metaKeywords"
      :title="metaTitle"
      :description="metaDescription"
      :keywords="metaKeywords"
    />
    <FooterComponent v-if="$vuetify.breakpoint.mdAndUp" />
  </v-container>
</template>

<script>
/*
Actions:
  Tab title translate
  Change store-load store info
  Redirect if the store slug it doesn`t exist
*/
import {
  ProductList,
  CheckoutBar,
  OffersComponent,
  StoreCloseNotification,
  StoreInfoBar,
  CategoryBar,
} from "./components";
import MetaDataComponent from "@/components/metaDataComponent/MetaDataComponent.vue";
import FooterComponent from "@/views/front/home/components/FooterComponent.vue";
import storeCoverImage from "@/assets/img/home/storeCover.png";

export default {
  layout: "Public",
  name: "Discovery",
  components: {
    FooterComponent,
    MetaDataComponent,
    ProductList,
    StoreInfoBar,
    CategoryBar,
    CheckoutBar,
    OffersComponent,
    StoreCloseNotification,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    showInfoCheckout: false,
    lastMenuPosition: 0,
    lastCategoryPosition: 0,
    isValidRoute: false,
    showModal: false,
    tableIdInput: null,
  }),
  computed: {
    banner: {
      get() {
        return storeCoverImage;
      },
    },
    metaTitle() {
      return this.$store.getters.appInfo.menuMetaTitle;
    },
    metaDescription() {
      return this.$store.getters.appInfo.menuMetaDescription;
    },
    metaKeywords() {
      return this.$store.getters.appInfo.menuMetaKeywords;
    },
  },
  watch: {
    "$store.getters.storeInfo": function () {
      this.$store.dispatch("storeInfo/loadStoreMenu");
    },
    $route: function (to, from) {
      if (to.params.tableId !== from.params.tableId) {
        this.validateRoute(this.$route.params.tableId);
      }
    },
  },
  async beforeCreate() {
    this.$store.dispatch("storeInfo/loadStoreMenu");
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.$route.params.tableId) {
      this.validateRoute(this.$route.params.tableId);
    }
  },
  methods: {
    handleTabSelect() {
      const tagBar = this.$refs.tagBar;
      const categoryBar = this.$refs.categoryBar;
      tagBar.classList.add("fixed"); // add a CSS class to fix the position
      categoryBar.classList.add("fixed-tag"); // add a CSS class to fix the position
      if (this.$vuetify.breakpoint.mdAndUp) {
        $(".menu").css("height", "auto");
        this.showInfoCheckout = true;
      } else {
        $(".menu").css("height", "0px");
      }
    },
    handleScroll() {
      const tagBar = this.$refs.tagBar;
      const categoryBar = this.$refs.categoryBar;

      // Add null checks to prevent errors
      if (!tagBar || !categoryBar) {
        return;
      }

      // const tagBarOneHeight = this.$refs.tagBar.clientHeight;
      // console.log({ tagBarOneHeight });
      // if (window.scrollY > categoryBar.offsetTop) {
      //   categoryBar.classList.add("fixed");
      //   if (this.lastCategoryPosition === 0) {
      //     this.lastCategoryPosition = window.scrollY;
      //   }
      // } else {
      //   categoryBar.classList.remove("fixed");
      // }
      // if (window.scrollY < this.lastCategoryPosition) {
      //   categoryBar.classList.remove("fixed");
      // }
      if (window.scrollY > tagBar.offsetTop) {
        tagBar.classList.add("fixed"); // add a CSS class to fix the position
        categoryBar.classList.add("fixed-tag"); // add a CSS class to fix the position
        if (this.$vuetify.breakpoint.mdAndUp) {
          $(".menu").css("height", "auto");
          this.showInfoCheckout = true;
        } else {
          $(".menu").css("height", "0px");
        }
        if (this.lastMenuPosition === 0) {
          this.lastMenuPosition = window.scrollY;
        }
      } else {
        tagBar.classList.remove("fixed"); // remove the CSS class to reset the position
        categoryBar.classList.remove("fixed-tag"); // remove the CSS class to reset the position
        if (this.$vuetify.breakpoint.mdAndUp) {
          this.showInfoCheckout = false;

          $(".menu").css("height", "auto");
        }

        // Add safety checks for jQuery calls
        const headerBackground = $(".header-background");
        const menu = $(".menu");
        const cardCategories = $(".card-categories");

        if (headerBackground.length && menu.length && cardCategories.length) {
          var altura_container = headerBackground.outerHeight(true);
          var altura_del_menu = menu.outerHeight(true);
          if ($(window).scrollTop() >= altura_container - altura_del_menu) {
            cardCategories.addClass("fixed-categories");
          } else {
            cardCategories.removeClass("fixed-categories");
          }
        }
      }
      if (window.scrollY < this.lastMenuPosition) {
        tagBar.classList.remove("fixed"); // remove the CSS class to reset the position
        categoryBar.classList.remove("fixed-tag"); // remove the CSS class to reset the position
        if (this.$vuetify.breakpoint.mdAndUp) {
          this.showInfoCheckout = false;
          $(".menu").css("height", "auto");
        }

        // Add safety checks for jQuery calls in this section too
        const headerBackground2 = $(".header-background");
        const menu2 = $(".menu");
        const cardCategories2 = $(".card-categories");

        if (
          headerBackground2.length &&
          menu2.length &&
          cardCategories2.length
        ) {
          var altura_container = headerBackground2.outerHeight(true);
          var altura_del_menu = menu2.outerHeight(true);
          if ($(window).scrollTop() >= altura_container - altura_del_menu) {
            cardCategories2.addClass("fixed-categories");
          } else {
            cardCategories2.removeClass("fixed-categories");
          }
        }
      }
    },
    validateRoute(id, isSetUrl) {
      axios
        .get(`/app/store/${this.$store.getters.storeInfo.id}/availableTables`, {
          params: {
            table_id: id,
          },
        })
        .then((response) => {
          this.isValidRoute = response.data.data;
          if (response.data.data === false) {
            this.showModal = true;
            if (isSetUrl) {
              Swal.fire({
                icon: "error",
                title: this.$t("errors.error_alert_title"),
                text: this.$t("general.confirmTable"),
                reverseButtons: true,
                confirmButtonText: "ok",
              });
            }
          } else if (isSetUrl) {
            this.showModal = false;
            this.$router.push(
              `/${this.$store.getters.storeInfo.slug}/menu/${id}`
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.input-box {
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 8px;
  border-radius: 4px;
}

.text-input {
  flex-grow: 1;
  margin-right: 8px;
}
.bg-color-mobile {
  background-color: white !important;
}
.bg-color {
  background-color: #fbfbfb;
}
.content-mobile {
  padding-left: 5px;
  padding-right: 5px;
}
.category-container {
  max-width: 1400px;
  margin: 0 auto;
}
.img-inner-container {
  max-width: 1450px;
  margin: 0 auto;
}
@media screen and (max-width: 768px) {
  .category-container {
    max-width: none;
  }
}
.header {
  height: 90px;
  width: 100vw;
}
.menu {
  width: 100vw;
}
.img-bc {
  justify-content: center;
  display: flex;
}
.img-bc-mt {
  margin-top: unset !important;
}
.wrapper {
  height: 800px;
  width: 100vw;
  padding-top: 20px;
}
.fixed {
  position: fixed;
  top: 0;
  background-color: white;
  z-index: 9;
  border-bottom: solid;
  border-color: rgba($color: #706f6f, $alpha: 0.5);
  border-width: 0.5px;
  width: 100vw;
}
.fixed-tag {
  background-color: white;
  z-index: 9;
  border-bottom: solid;
  border-color: rgba($color: #706f6f, $alpha: 0.5);
  border-width: 0.5px;
  width: 100vw;
}
.fixed-categories {
  position: fixed;
  top: 0;
  z-index: 9;
}
.store-title {
  color: white;
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.store-subtitle {
  color: white;
  font-size: 1rem !important;
  line-height: 2rem !important;
}
@media screen and (max-width: 930px) {
  store-title {
    font-size: 1.4rem !important;
    line-height: 2rem !important;
  }
  .store-subtitle {
    font-size: 0.8rem !important;
    line-height: 1rem !important;
  }
}
@media only screen and (min-width: 320px) and (max-width: 479px) {
  .container-discovery {
    padding-bottom: 100px !important;
  }
  .header {
    height: 55px;
  }
  .menu {
    z-index: 1;
    height: 0px;
  }
  .fixed {
    z-index: 1;
    border-bottom: transparent;
    border-color: transparent;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .container-discovery {
    padding-bottom: 100px !important;
  }
  .header {
    height: 55px;
  }
  .menu {
    z-index: 1;
    height: 0px;
  }
  .fixed {
    z-index: 1;
    border-bottom: transparent;
    border-color: transparent;
  }
}

@media only screen and (min-width: 768px) and (max-width: 999px) and (orientation: landscape) {
  .container-discovery {
    padding-bottom: 100px !important;
  }
  .header {
    height: 55px;
  }
  .menu {
    z-index: 1;
    height: 0px;
  }
  .fixed {
    z-index: 1;
    border-bottom: transparent;
    border-color: transparent;
  }
}

@media only screen and (min-width: 768px) and (max-width: 999px) and (orientation: portrait) {
  .container-discovery {
    padding-bottom: 100px !important;
  }
  .header {
    height: 55px;
  }
  .menu {
    z-index: 1;
    height: 0px;
  }
  .fixed {
    z-index: 1;
    border-bottom: transparent;
    border-color: transparent;
  }
}
</style>
